import { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { imgUrl } from "@/lib/api";

export const Lightbox = ({ photos, index, setIndex }) => {
  const open = index !== null && photos[index];
  useEffect(() => {
    if (!open) return;
    const h = (e) => {
      if (e.key === "Escape") setIndex(null);
      if (e.key === "ArrowRight") setIndex((index + 1) % photos.length);
      if (e.key === "ArrowLeft") setIndex((index - 1 + photos.length) % photos.length);
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, index, photos.length, setIndex]);
  if (!open) return null;
  const p = photos[index];
  return (
    <div className="fixed inset-0 z-[60] bg-black/95 flex items-center justify-center" onClick={() => setIndex(null)} data-testid="lightbox">
      <button className="absolute top-5 right-5 p-2 hover:text-red-500" onClick={() => setIndex(null)} data-testid="lightbox-close"><X size={30} /></button>
      <button className="absolute left-3 md:left-8 p-3 border border-zinc-700 hover:border-red-600 hover:text-red-500" onClick={(e) => { e.stopPropagation(); setIndex((index - 1 + photos.length) % photos.length); }} data-testid="lightbox-prev"><ChevronLeft /></button>
      <figure className="max-w-6xl w-full px-16" onClick={(e) => e.stopPropagation()}>
        <img src={imgUrl(p.url)} alt={p.title} className="max-h-[80vh] mx-auto object-contain" />
        {p.title && <figcaption className="text-center mt-4 font-display italic uppercase tracking-widest text-zinc-300">{p.title}</figcaption>}
      </figure>
      <button className="absolute right-3 md:right-8 p-3 border border-zinc-700 hover:border-red-600 hover:text-red-500" onClick={(e) => { e.stopPropagation(); setIndex((index + 1) % photos.length); }} data-testid="lightbox-next"><ChevronRight /></button>
    </div>
  );
};
